const items = [
  "ICAI Registered",
  "GSTN Authorized",
  "MCA Filings",
  "ROC Practitioner",
  "Income Tax",
  "Audit Quality Maturity",
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="border-y border-[#D1CEC5] bg-[#F3F0EA]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-wrap items-center justify-between gap-y-3 gap-x-10">
        {items.map((it, i) => (
          <div key={i} className="overline text-[10px] text-[#4A5D53]" data-testid={`trust-item-${i}`}>
            {it}
          </div>
        ))}
      </div>
    </section>
  );
}
